/**
 * Mirrors brian's `_frame` in `modules/notify/emit.py`. An event, not state: a
 * late subscriber has missed it.
 */
export interface NotificationEvent {
  type: string;
  uuid?: string;
  label?: string;
  /** Absent on create, `"updated"`, `"resurfaced"`. */
  op?: string;
  kind?: string;
  status?: string;
  /** `phone_call` frames only. */
  revision?: number;
  disclosure_state?: string;
  hold_state?: string;
  held_at?: string | null;
}

type Listener = (events: NotificationEvent[]) => void;
type ReconnectListener = () => void;

const listeners = new Set<Listener>();
const reconnectListeners = new Set<ReconnectListener>();

export const subscribeToFrames = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Called by the socket once per message, after it has invalidated caches. */
export const publishFrame = (events: NotificationEvent[]): void => {
  if (events.length === 0) return;
  for (const listener of listeners) listener(events);
};

/** A reconnect can follow a gap of any length: re-read everything tracked. */
export const subscribeToReconnect = (
  listener: ReconnectListener,
): (() => void) => {
  reconnectListeners.add(listener);
  return () => {
    reconnectListeners.delete(listener);
  };
};

export const publishReconnect = (): void => {
  for (const listener of reconnectListeners) listener();
};
